import Debug from 'HHC/Debug';

import 'HHC/Debug/Components';
import 'HHC/Debug/Error';
import 'HHC/Debug/Outer';

export default { install: Debug.init.bind(Debug) };
